exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".file-picker {\n  border-radius: 3px;\n  overflow: hidden;\n}\n", ""]);
